import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

interface ILetContext<T> {
  ngLet: T | undefined;
}

@Directive({
  selector: '[ngLet]'
})
export class NgLetDirective<T> {
  @Input()
  set ngLet(value: T) {
    this.context.ngLet = value;
  }
  private context: ILetContext<T> = { ngLet: undefined };

  constructor(viewContainer: ViewContainerRef, templateRef: TemplateRef<ILetContext<T>>) {
    viewContainer.createEmbeddedView(templateRef, this.context);
  }
}
